module.exports = __webpack_public_path__ + "static/media/maxim.8beb51f1.md";